const switches = {
  media: "00",
  question: "01",
  action: "10",
  note: "11",
};

export default switches;
